function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.72295 1.32547L8.45047 4.7245L11.0173 6.76388L7.79041 7.68642L6.58855 10.9068L4.86673 8.07801L1.55547 8.03248L3.71833 5.36095L2.87315 2.11293L5.93393 3.28736L8.72295 1.32547Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3492 14.7593C14.7685 15.1187 15.3998 15.0701 15.7593 14.6508C16.1187 14.2315 16.0701 13.6002 15.6508 13.2407L14.3492 14.7593ZM8.65079 7.24074C8.23147 6.88132 7.60017 6.92988 7.24074 7.34921C6.88132 7.76853 6.92988 8.39983 7.34921 8.75926L8.65079 7.24074ZM15.6508 13.2407L8.65079 7.24074L7.34921 8.75926L14.3492 14.7593L15.6508 13.2407Z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgMagic(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-magic",
    ref: svgRef
  }, props), _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.3aadab63.svg";
export { ForwardRef as ReactComponent };